module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "noindentc"
  }, [_vm._v("This book is dedicated to my inspiring mother, June, and to her much-loved father, Gunner John Smith-Pounder, who served in the 12th Battery, 6th Heavy Anti-Aircraft Regiment, Royal Artillery in Singapore in 1941. He, like most of his fellow artillerymen, was transferred to Java and fought as an infantryman during the fall of the Netherlands East Indies. Taken prisoner, he died in Pakan Baroe Japanese Prisoner of War Camp on Sumatra on 9 August 1945.")])]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("First published in Great Britain in 2019 by")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("PEN & SWORD MILITARY")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("an imprint of")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Pen & Sword Books Ltd,")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("47 Church Street,")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Barnsley, South Yorkshire, S70 2AS")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Copyright © Pen & Sword Books Limited, 2019")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Every effort has been made to trace the copyright of all the photographs.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("If there are unintentional omissions, please contact the publisher in writing, who will correct all subsequent editions.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("ISBN 978 1 52673 435 8")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("eISBN 978 152673 436 5")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Mobi ISBN 978 152673 437 2")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("The right of Philip Jowett to be identified as Author of this Work has been asserted by him in accordance with the Copyright, Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("A CIP record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical including photocopying, recording or by any information storage and retrieval system, without permission from the Publisher in writing.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Pen & Sword Books Ltd incorporates the imprints of Pen & Sword Aviation, Pen & Sword")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Family History, Pen & Sword Maritime, Pen & Sword Military, Pen & Sword Discovery,")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Wharncliffe Local History, Wharncliffe True Crime, Wharncliffe Transport, Pen and Sword")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Select, Pen and Sword Military Classics, Leo Cooper, The Praetorian Press, Remember")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("When, Seaforth Publishing and Frontline Publishing and White Owl")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("For a complete list of Pen & Sword titles please contact")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Pen & Sword Books Limited")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("47 Church Street, Barnsley, South Yorkshire, S70 2AS, England")])]), _c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_vm._v("E-mail:"), _c('span', {
    staticClass: "weblink"
  })]), _c('a', {
    attrs: {
      "href": "mailto:enquiries@pen-and-sword.co.uk"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("enquiries@pen-and-sword.co.uk")])])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Website: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.pen-and-sword.co.uk",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.pen-and-sword.co.uk")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73bdc7ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Copyright.vue
// module id = 66
// module chunks = 0